import React, { useState, useContext } from 'react';
import { TextField, Button, Container, Typography, CircularProgress } from '@mui/material';
import { API } from '../conf';
import { Buffer } from 'buffer';
import { Context } from '../App';

const Login = () => {
    const { updateConnect, setAccess} = useContext(Context)
    const [identifier, setIdentifier] = useState('');
    const [loading, setLoad] = useState(false);
    const [msg, setMsg] = useState();

    const handleSubmit = (event) => {
        event.preventDefault();
        if (identifier.length > 0) {
            setLoad(true)
            fetch(API.concat('/login'), {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic '+Buffer.from(identifier,'utf-8').toString('base64'),
                },
            })
            .then(async(response)=> {
                if(response.status === 200)  {
                    const user = await response.json()
                    sessionStorage.setItem('user', JSON.stringify(user))
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    setAccess(user.access)
                    updateConnect(true);
                }else{
                    const text = await response.json()
                    setMsg(text.error)
                    setLoad(false)
                }
            })
        }
    };

    return (
        <Container maxWidth="sm">
            <Typography variant="h4" component="h2" textAlign='center' gutterBottom>
                Login
            </Typography>
            <form onSubmit={handleSubmit}>
                <Typography color={'carmine.main'}>{msg}</Typography>
                <TextField
                    label="Identifiant"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    required
                />
                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading} >
                    {loading&&<CircularProgress size={18} color='primary' style={{marginRight:7}}/>} Connexion
                </Button>
            </form>
        </Container>
    );
};

export default Login;